import { useInterval } from "@chakra-ui/react"
import { useCallback, useRef, useState } from "react"
import { useEffectOnce } from "react-use"
import { usePrinticularApi } from "~/hooks/usePrinticularApi"
import { TemporaryCredentials } from "~/interfaces/entities/TemporaryCredentials"

export const usePrinticularMapTemporaryCredentials = () => {
  const api = usePrinticularApi()
  const [isReady, setIsReady] = useState(false)
  const [credentials, setCredentials] = useState<TemporaryCredentials>()
  const isMounted = useRef(true)

  const refreshCredentials = useCallback(async () => {
    const creds = await api.getTempCredentials()

    // Only update state if component is mounted
    if (isMounted.current) {
      setCredentials(creds)
    }
  }, [api])

  useEffectOnce(() => {
    const fetchCredentials = async () => {
      await refreshCredentials()
      if (isMounted.current) {
        setIsReady(true)
      }
    }

    fetchCredentials()
    // Set to false when component unmounts
    return () => {
      isMounted.current = false
    }
  })

  useInterval(async () => {
    if (isMounted.current) {
      refreshCredentials()
    }
  }, 1000 * 60 * 40) // every 40 minutes (creds are valid for 1 hour)

  return { credentials, isReady }
}
